<!-- Ladebildschirm -->
@if (loading) {
  <div class="ui active dimmer fullscreen">
    <div class="ui large text loader">Loading...</div>
  </div>
}

<!-- Fehlermeldung (kein Event / kein Mediathek-Token / etc.) -->
@if (!loading && !authMode && errorMessage) {
  <div class="ui centered grid">
    <div class="login">
      <div class="ui visible warning message" style="width: 100%">
        {{ errorMessage }}
      </div>
    </div>
  </div>
}



<!-- ═══════════ EMAIL_TOKEN: E-Mail-Bestätigungs-Flow ═══════════ -->
@if (!loading && authMode === AuthMode.EMAIL_TOKEN) {
  <div class="ui centered grid">
    <div class="login">
      <div class="">
          <div class="loginHeadline">
            @if (eventTitle) {
              <h1>{{ eventTitle }}</h1>
              @if (eventSubtitle) {
                <h2>{{ eventSubtitle }}</h2>
              }
            }
          </div>
        <div class="row">
          <div class="column">
            <div class="loginForm">
               <h2>{{ eLangGlob()?.translateEmailRequest }}</h2>
              <!-- E-Mail noch nicht gesendet → Formular -->
              @if (!emailSent && !isLoggedIn) {
                <form
                  class="ui form"
                  name="form"
                  (ngSubmit)="f.form.valid && onSubmit()"
                  #f="ngForm"
                  novalidate
                >
                  <div class="field">
                    <label for="email">{{ eLangGlob()?.translateEmail }}</label>
                    <input
                      type="email"
                      name="email"
                      [(ngModel)]="form.email"
                      required
                      #email="ngModel"
                    />
                  </div>
                  @if (f.submitted && email.invalid) {
                    <div class="visible warning message" role="alert">
                      {{ eLangGlob()?.translateNoUsername }}
                    </div>
                  }
                  <div class="field btnLogin">
                    <span class="btn_login_left"></span>
                    <button>
                      {{ deliveryMode === 'code' ? 'Code anfordern' : eLangGlob()?.translateSendLink }}
                    </button>
                    <span class="btn_login_right"></span>
                  </div>
                  @if (f.submitted && isLoginFailed) {
                    <div class="ui visible warning message" style="width: 100%" role="alert">
                      {{ errorMessage || eLangGlob()?.translatePWError }}
                    </div>
                  }
                </form>
              }

              <!--
                Mail ist raus. Beim Link bleibt nur der Hinweis; beim Code folgt hier die
                Eingabe, weil der Zuschauer sechs Ziffern eintippt statt zu klicken.
              -->
              @if (emailSent && !isLoggedIn) {
                @if (deliveryMode !== 'code') {
                  <div class="ui visible info message" style="width: 100%">
                    <p>{{ eLangGlob()?.translateEmailSendConfirmation }}</p>
                  </div>
                }

                @if (deliveryMode === 'code') {
                  <!--
                    Eigener Text: translateEmailSendConfirmation spricht vom Anklicken
                    eines Links, den es in diesem Modus nicht gibt.
                  -->
                  <div class="ui visible info message" style="width: 100%">
                    <p>Wir haben Ihnen einen sechsstelligen Code geschickt. Bitte prüfen Sie Ihr Postfach.</p>
                  </div>

                  <form
                    class="ui form"
                    name="codeForm"
                    (ngSubmit)="onSubmitCode()"
                    novalidate
                  >
                    <div class="field">
                      <label for="confirmationCode">Code aus der E-Mail</label>
                      <!--
                        (input) statt (ngModelChange): das Feld muss auch dann korrigiert
                        werden, wenn der gefilterte Wert dem bisherigen entspricht. Beim
                        Tippen eines Buchstabens bleibt das Modell '' — ngModel sieht
                        keine Änderung und lässt den Buchstaben im Feld stehen.
                      -->
                      <input
                        #codeInput
                        type="text"
                        name="confirmationCode"
                        [(ngModel)]="confirmationCode"
                        (input)="onCodeInput(codeInput)"
                        inputmode="numeric"
                        autocomplete="one-time-code"
                        maxlength="6"
                        placeholder="000000"
                        style="letter-spacing: 6px; text-align: center; font-size: 20px"
                        required
                      />
                    </div>
                    @if (codeHadInvalidChars) {
                      <div style="color: #8a6d3b; margin-bottom: 10px">
                        Der Code besteht nur aus Ziffern.
                      </div>
                    }
                    <div class="field btnLogin">
                      <span class="btn_login_left"></span>
                      <button [disabled]="codeSubmitting || confirmationCode.trim().length !== 6">
                        Anmelden
                      </button>
                      <span class="btn_login_right"></span>
                    </div>
                    @if (isLoginFailed) {
                      <div class="ui visible warning message" style="width: 100%" role="alert">
                        {{ errorMessage }}
                      </div>
                    }
                    <div class="field">
                      <a href="javascript:void(0)" (click)="requestNewCode()">
                        Neuen Code anfordern
                      </a>
                    </div>
                  </form>
                }
              }

              <!-- Eingeloggt -->
              @if (isLoggedIn) {
                <div class="ui visible success message">
                  {{ eLangGlob()?.translateLoggedInAs }}:<strong> {{ email }}</strong><br />
                </div>
              }

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}

<!-- ═══════════ EMAIL_PASSWORD: Benutzername + Passwort ═══════════ -->
@if (!loading && authMode === AuthMode.EMAIL_PASSWORD) {
  <div class="ui centered grid">
    <div class="login">
      <div class="">
        <div class="row">
          <div class="loginHeadline">
            @if (eventTitle) {
              <h1>{{ eventTitle }}</h1>
              @if (eventSubtitle) {
                <p>{{ eventSubtitle }}</p>
              }
            }
            <h2>{{ eLangGlob()?.translatePWRequest }}</h2>
          </div>
        </div>
        <div class="row">
          <div class="column">
            <div class="loginForm">
              @if (!isLoggedIn) {
                <form
                  class="ui form"
                  name="form"
                  (ngSubmit)="f.form.valid && onSubmit()"
                  #f="ngForm"
                  novalidate
                >
                  <div class="field">
                    <label for="email">{{ eLangGlob()?.translateUsername }}</label>
                    <input
                      type="text"
                      name="email"
                      [(ngModel)]="form.email"
                      required
                      #email="ngModel"
                    />
                  </div>
                  @if (f.submitted && email.invalid) {
                    <div class="visible warning message" role="alert">
                      {{ eLangGlob()?.translateNoUsername }}
                    </div>
                  }

                  <div class="field">
                    <label for="password">{{ eLangGlob()?.translatePassword }}</label>
                    <input
                      type="password"
                      name="password"
                      [(ngModel)]="form.password"
                      required
                      minlength="6"
                      #password="ngModel"
                    />
                  </div>
                  @if (f.submitted && password.invalid) {
                    <div class="ui visible warning message" role="alert">
                      @if (password.errors?.['required']) {
                        <div>{{ eLangGlob()?.translateNoPW }}</div>
                      }
                      @if (password.errors?.['minlength']) {
                        <div>{{ eLangGlob()?.translatePWtooShort }}</div>
                      }
                    </div>
                  }

                  <div class="field btnLogin">
                    <span class="btn_login_left"></span>
                    <button>{{ eLangGlob()?.translateBtnLogin }}</button>
                    <span class="btn_login_right"></span>
                  </div>
                  <div class="field">
                    @if (f.submitted && isLoginFailed) {
                      <div class="ui visible warning message" style="width: 100%" role="alert">
                        {{ errorMessage || eLangGlob()?.translatePWError }}
                      </div>
                    }
                  </div>
                </form>
              }
              @if (isLoggedIn) {
                <div class="ui two column centered grid">
                  <div class="row">
                    <div class="two columns">
                      <div class="ui visible success message">
                        {{ eLangGlob()?.translateLoggedInAs }}:<strong> {{ email }}</strong><br />
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}

<!-- ═══════════ MEDIA_LIBRARY: Fehleranzeige (automatischer Login) ═══════════ -->
@if (!loading && authMode === AuthMode.MEDIA_LIBRARY && errorMessage) {
  <div class="ui centered grid">
    <div class="login">
      <div class="medialibFallback">
        <div class="ui visible warning message" style="width: 100%">
          {{ errorMessage }}
        </div>

        <!-- Ausweg: die reguläre Anmeldung des Events, falls es eine gibt -->
        @if (fallbackAuthMode) {
          <div class="field btnLogin">
            <span class="btn_login_left"></span>
            <button type="button" (click)="useRegularLogin()">
              {{ eLangGlob()?.translateBtnLogin }}
            </button>
            <span class="btn_login_right"></span>
          </div>
        }

        <!-- Zweiter Weg: zurück ins Dashboard, das einen neuen Token ausstellt -->
        @if (backToMediaLibrary()) {
          <a class="media_library" [href]="backToMediaLibrary()">
            <div class="media_library_arrow_left"></div>
            <span class="media_library_text">{{ eLangGlob()?.translateMediaLibraryLong }}</span>
          </a>
        }
      </div>
    </div>
  </div>
}
